import { DynamicContentBlock } from "components/information-lister-pages/DynamicContentBlock";
import React from "react";
import { Content } from "./elements/Content";

export const DynamicContent = ({ content, children, ...rest }) => {
    if (!content) {
        return <Content>{children}</Content>;
    }

    const { type, dynamicContentList } = content;

    const newListenerListener = dynamicContentList
        ?.filter((item) => item._id !== "4ieqYrbpk7MULt3nFKmPxK")
        .map((item) => {
            if (item._id === "1VfjoQQD2pD3XK1EBcp47p") {
                const newLinksData = item.links.slice(0, 4);
                return { ...item, links: newLinksData };
            }
            return { ...item };
        });

    return (
        <Content>
            {children}
            {!!newListenerListener &&
                // to filter out content blocks available only in preview
                newListenerListener.map(
                    (block) =>
                        block?._type && (
                            <DynamicContentBlock
                                key={block._id}
                                title={type}
                                {...block}
                                {...rest}
                            />
                        )
                )}
        </Content>
    );
};

DynamicContent.displayName = "DynamicContent";

DynamicContent.getContextProps = async (content) => {
    if (content?.dynamicContentList) {
        const dynamicContentList = await Promise.all(
            content.dynamicContentList.map((block) => DynamicContentBlock.getContextProps(block))
        );
        return { ...content, dynamicContentList };
    }
    return content;
};
